import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Avatar from '@material-ui/core/Avatar';
import Box from '@material-ui/core/Box';
import Card from '@material-ui/core/Card';
import Tooltip from '@material-ui/core/Tooltip';
import CardContent from '@material-ui/core/CardContent';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import Button from 'components/common/Button';

const useStyles = makeStyles((theme) => ({
  root: {
    border: '1px solid rgba(105, 109, 117, 0.2)',
    height: '100%',
  },
  avatar: {
    width: 80,
    height: 80,
    margin: 'auto',
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(3),
  },
}));

const ContactCard = ({ contact, onInvite, onDelete }) => {
  const classes = useStyles();

  const handleInvite = () => {
    return onInvite(contact);
  };

  const handleDelete = () => {
    onDelete(contact);
  };

  return (
    <Card className={classes.root}>
      <CardContent
        component={Box}
        textAlign="center"
        position="relative"
        display="flex"
        flexDirection="column"
        height="100%"
      >
        {!contact.invited && (
          <Box position="absolute" right={1} top={1}>
            <Tooltip title="Remove contact">
              <IconButton onClick={handleDelete}>
                <CloseIcon />
              </IconButton>
            </Tooltip>
          </Box>
        )}
        <Avatar src={contact.photo} className={classes.avatar} />
        <Typography gutterBottom variant="subtitle1">
          {contact.first_name} {contact.last_name}
        </Typography>
        <Typography paragraph color="textSecondary">
          {contact.email || contact.phone}
        </Typography>
        <Box mt="auto">
          <Button color="primary" variant="outlined" onClick={handleInvite}>
            {contact.invited ? 'Resend' : 'Invite'}
          </Button>
        </Box>
      </CardContent>
    </Card>
  );
};

export default ContactCard;
